import * as preact from "preact";

const Check: preact.FunctionComponent = () => (
  <svg
    width="13"
    height="11"
    viewBox="0 0 21 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.82171 13.6113L20.4398 2.99322L17.6113 0.164798L6.99329 10.7828L2.82849 6.61804L6.22271e-05 9.44647L6.99346 16.4399L9.82189 13.6114L9.82171 13.6113Z"
      fill="currentColor"
    />
  </svg>
);

export default Check;
